import React from "react";
import {
  Grid,
  Box,
  Typography,
  makeStyles,
  useMediaQuery,
} from "@material-ui/core";
import { useSelector } from "react-redux";
import { primaryColor } from "resources/constants";
import ScaleLoader from "react-spinners/ScaleLoader";
import mixpanelTrack from "app/common/MixpanelComponent";
import CompetitorsCrossEffectComponent from "./CompetitorsCrossEffectComponent";
import ProductComparatorComponent from "./product_comparator/ProductComparatorComponent";
import MarketShareComponent from "./market_share/MarketShareComponent";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: "1",
    minHeight: 0,
  },
  headerContainer: {
    display: "flex",
    borderBottom: "1px solid #e2e2e2",
    marginBottom: "10px",
    marginLeft: "10px",
    marginRight: "10px",
    flexWrap: "nowrap",
    [theme.breakpoints.down("xs")]: {
      flexWrap: "wrap",
      paddingBottom: "10px",
    },
  },
  headerTitle: {
    paddingBottom: theme.spacing(1.5),
  },
  spinnerContainer: {
    display: "flex",
    flexGrow: "1",
    alignItems: "center",
    justifyContent: "center",
  },
  halfHeight: theme.halfHeight,
  componentContainer: {
    maxHeight: "100%",
  },
}));

function CompetitorsOldComponent() {
  const classes = useStyles();
  const dataloadSlice = useSelector((state) => state.dataload);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  React.useEffect(() => {
    /* MIXPANEL TRACKS */
    mixpanelTrack("Competitors module visited");
    /* END OF MIXPANEL TRACKS */
  }, []);

  return (
    <>
      {dataloadSlice.selectedDataload.id ? (
        <>
          <Box className={classes.headerContainer}>
            <Typography variant="h6" className={classes.headerTitle}>
              Competitor Analysis
            </Typography>
          </Box>
          <Grid container className={classes.root}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={6}
              className={classes.componentContainer}
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                className={!isSmallScreen && classes.halfHeight}
              >
                <MarketShareComponent />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                className={!isSmallScreen && classes.halfHeight}
              >
                <CompetitorsCrossEffectComponent />
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={6}
              className={classes.componentContainer}
            >
              <ProductComparatorComponent />
            </Grid>
          </Grid>
        </>
      ) : (
        <Box component="div" className={classes.spinnerContainer}>
          <ScaleLoader size={150} color={primaryColor} loading />
        </Box>
      )}
    </>
  );
}

export default CompetitorsOldComponent;
